const GETTERS = {
  currentColumns(state, getters, rootState) {
    return state.columns[rootState.tools.baseReportName] || []
  },
}

export default GETTERS
